import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import styled from "styled-components";
import mapleLeaf from "../../../assets/images/canadian-maple-leaf-brands.svg";

import { getEstimatedDelivery } from "../../../utils/bedBuilder.utils";

import SubTitle from "./SubTitle";
import Title from "./Title";

const StyledTitleContainer = styled.div`
  margin-top: 1rem;
  position: relative;
  left: -90px;
  top: -30px;
`;
const GeneralStepsHeader = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <StyledTitleContainer className={"evrbed-title"}>
        <Title>{t("evrbed")}</Title>
      </StyledTitleContainer>
      <SubTitle>{`Est. delivery   :  ${getEstimatedDelivery()} `}</SubTitle>

      <SubTitle styles={{ marginTop: "-4px" }}>
        <img src={mapleLeaf}></img>
        {t("  Made in Canada")}
      </SubTitle>
      <div
        style={{
          color: theme.COLORS.WHITE.backgroundWhite,
          marginTop: "-1rem",
        }}
      >
        ___________________
      </div>
    </>
  );
};

export default GeneralStepsHeader;
